<template>
    <div class="container-showcase">
        <div class="container-fluid ba-card">
                <p>{{ decodeString(translation.text_explanation_rank_all_time) }}</p>
            <div class="title__rank">
                <span>{{translation.top_affiliates_all_times}}</span>
            </div>
            <div class="card simplified-4" v-if="this.rankAllTime.length != 0 && !this.isBr">
                <div class="showcase">
                    <div class="rank__3">
                        <div class="rank__3--in">
                            <div class="rank__row" v-for="(lead, i_3) in this.allTimeRank3" :key="i_3">
                                <div class="box__left" v-if="lead != ''">
                                    <div class="box__image">
                                        <span class="index">{{i_3 == 0 ? 2 : i_3 == 1 ? 1 : 3}}</span>
                                        <img :src="lead.image" />
                                    </div>
                                    <h5 class="name">{{lead.name}}</h5>
                                    <h5 class="points">{{lead.points}}pt</h5>
                                </div>
                            </div>
                        </div>
                        <span class="last__updated first">{{translation.last_updated + ' ' + handleDateFormat(lastUpdated)}}</span>
                    </div>
                    <div class="customer scroll">
                        <div
                            class="customer__row"
                            v-for="(lead, index) in this.allTimeRank3Above"
                            :key="index"
                        >
                            <div class="box__left" v-if="lead != ''">
                                <span class="index">{{Number(index) + 1}}</span>
                                <img :src="lead.image" />
                                <h5>{{lead.name}}</h5>
                            </div>
                            <h5 class="points" v-if="lead != ''">{{lead.points}}pt</h5>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div  v-if="this.rankMonth.length != 0">
                <p>{{translation.text_explanation_rank_montlhy}}</p>
                <div class="title__rank">
                    <span>{{translation.top_affiliates_only}}</span>
                </div>
                <div class="card simplified-4">
                    <div class="showcase__simplified">
                        <div class="left">
                            <div
                                class="customer__row"
                                v-for="(lead, i_rt_5) in this.monthRank5"
                                :key="i_rt_5"
                            >
                                <div class="box__left" v-if="lead != ''">
                                    <div class="box__image">
                                        <span class="index">{{i_rt_5}}</span>
                                        <img :src="lead.image" />
                                    </div>
                                    <h5 class="name">{{lead.name}}</h5>
                                    <h5 class="points">{{lead.points}}pt</h5>
                                </div>
                            </div>
                        </div>
                        <div class="right scroll">
                            <div
                                class="customer__row"
                                v-for="(lead, i_rt_5) in this.monthRank5Above"
                                :key="i_rt_5"
                            >
                                <div class="box__left" v-if="lead != ''">
                                    <div class="box__image">
                                        <span class="index">{{i_rt_5}}</span>
                                        <img :src="lead.image" />
                                    </div>
                                    <h5 class="name">{{lead.name}}</h5>
                                    <h5 class="points">{{lead.points}}pt</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span class="last__updated">{{translation.last_updated + ' ' + handleDateFormat(lastUpdated)}}</span>
                </div>
            </div>
            <br>
            <div v-if="this.rankToday.length != 0">
                <p>{{translation.text_explanation_rank_diary}}</p>
                <div class="title__rank">
                    <span>{{translation.top_affiliates_today}}</span>
                    <!-- <span>{{translation.top_affiliates_all_times}}</span> -->
                </div>
                <div class="card simplified-4">
                    <div class="showcase__simplified">
                        <div class="left">
                            <div
                                class="customer__row"
                                v-for="(lead, i_rt_5) in this.dayRank5"
                                :key="i_rt_5"
                            >
                                <div class="box__left" v-if="lead != ''">
                                    <div class="box__image">
                                        <span class="index">{{i_rt_5}}</span>
                                        <img :src="lead.image" />
                                    </div>
                                    <h5 class="name">{{lead.name}}</h5>
                                    <h5 class="points">{{lead.points}}pt</h5>
                                </div>
                            </div>
                        </div>
                        <div class="right scroll">
                            <div
                                class="customer__row"
                                v-for="(lead, i_rt_5) in this.dayRank5Above"
                                :key="i_rt_5"
                            >
                                <div class="box__left" v-if="lead != ''">
                                    <div class="box__image">
                                        <span class="index">{{i_rt_5}}</span>
                                        <img :src="lead.image" />
                                    </div>
                                    <h5 class="name">{{lead.name}}</h5>
                                    <h5 class="points">{{lead.points}}pt</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span class="last__updated">{{translation.last_updated + ' ' + handleDateFormat(lastUpdated)}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
    name: "affiliates-show-case",
    props: ["view"],
    components: {},
    data() {
        return {
            translation: this.view.translation.affiliatesShowCase,
            rankAllTime: [],
            rankMonth: [],
            rankToday: [],
            allResponse: null,
            isBr: this.view.IS_BR,
            urlLink: this.view.urls["rota_ranking"],
            allTimeRank3: {},
            allTimeRank3Above: {},
            monthRank5: {},
            monthRank5Above: {},
            dayRank5: {},
            dayRank5Above: {},
            lastUpdated: null
        };
    },
    methods: {
        decodeString(val) {
          return new DOMParser().parseFromString(val, 'text/html').querySelector('body').textContent;
        },
        handleRanking() {
            let vm = this;
            // fetch(`${window.__env.microservices.bucket.host}/ranking`, {
            fetch("https://bucket.services.builderall.com/ranking", {
                mode: "cors",
                headers: {
                    Origin: "*"
                }
            })
                .then(res => {
                    return res.text();
                })
                .then(data => {
                    vm.allResponse = JSON.parse(data);
                    vm.rankAllTime = this.allResponse.all;
                    vm.rankMonth = this.allResponse.month;
                    vm.rankToday = this.allResponse.now;
                    vm.lastUpdated = this.allResponse.updated_at;

                    //split the winners
                    vm.allTimeRank3 = {
                        0: vm.rankAllTime["1"] ? vm.rankAllTime["1"] : "",
                        1: vm.rankAllTime["0"] ? vm.rankAllTime["0"] : "",
                        2: vm.rankAllTime["2"] ? vm.rankAllTime["2"] : ""
                    };
                    vm.allTimeRank3Above = {
                        3: vm.rankAllTime["3"] ? vm.rankAllTime["3"] : "",
                        4: vm.rankAllTime["4"] ? vm.rankAllTime["4"] : "",
                        5: vm.rankAllTime["5"] ? vm.rankAllTime["5"] : "",
                        6: vm.rankAllTime["6"] ? vm.rankAllTime["6"] : "",
                        7: vm.rankAllTime["7"] ? vm.rankAllTime["7"] : "",
                        8: vm.rankAllTime["8"] ? vm.rankAllTime["8"] : "",
                        9: vm.rankAllTime["9"] ? vm.rankAllTime["9"] : "",
                        10: vm.rankAllTime["10"] ? vm.rankAllTime["10"] : "",
                        11: vm.rankAllTime["11"] ? vm.rankAllTime["11"] : "",
                        12: vm.rankAllTime["12"] ? vm.rankAllTime["12"] : "",
                        13: vm.rankAllTime["13"] ? vm.rankAllTime["13"] : ""
                    };

                    vm.monthRank5 = {
                        1: vm.rankMonth["0"] ? vm.rankMonth["0"] : "",
                        // 1: this.getFakeUser("month", vm.rankMonth["0"].points),
                        2: vm.rankMonth["1"] ? vm.rankMonth["1"] : "",
                        3: vm.rankMonth["2"] ? vm.rankMonth["2"] : "",
                        4: vm.rankMonth["3"] ? vm.rankMonth["3"] : "",
                        5: vm.rankMonth["4"] ? vm.rankMonth["4"] : ""
                    };
                    vm.monthRank5Above = {
                        6: vm.rankMonth["5"] ? vm.rankMonth["5"] : "",
                        7: vm.rankMonth["6"] ? vm.rankMonth["6"] : "",
                        8: vm.rankMonth["7"] ? vm.rankMonth["7"] : "",
                        9: vm.rankMonth["8"] ? vm.rankMonth["8"] : "",
                        10: vm.rankMonth["9"] ? vm.rankMonth["9"] : "",
                        11: vm.rankMonth["10"] ? vm.rankMonth["10"] : "",
                        12: vm.rankMonth["11"] ? vm.rankMonth["11"] : "",
                        13: vm.rankMonth["12"] ? vm.rankMonth["12"] : "",
                        14: vm.rankMonth["13"] ? vm.rankMonth["13"] : "",
                    };

                    vm.dayRank5 = {
                        1: vm.rankToday["0"] ? vm.rankToday["0"] : "",
                        // 1: this.getFakeUser("day", vm.rankToday["0"].points),
                        2: vm.rankToday["1"] ? vm.rankToday["1"] : "",
                        3: vm.rankToday["2"] ? vm.rankToday["2"] : "",
                        4: vm.rankToday["3"] ? vm.rankToday["3"] : "",
                        5: vm.rankToday["4"] ? vm.rankToday["4"] : ""
                    };
                    vm.dayRank5Above = {
                        6: vm.rankToday["5"] ? vm.rankToday["5"] : "",
                        7: vm.rankToday["6"] ? vm.rankToday["6"] : "",
                        8: vm.rankToday["7"] ? vm.rankToday["7"] : "",
                        9: vm.rankToday["8"] ? vm.rankToday["8"] : "",
                        10: vm.rankToday["9"] ? vm.rankToday["9"] : "",
                        11: vm.rankToday["10"] ? vm.rankToday["10"] : "",
                        12: vm.rankToday["11"] ? vm.rankToday["11"] : "",
                        13: vm.rankToday["12"] ? vm.rankToday["12"] : "",
                        14: vm.rankToday["13"] ? vm.rankToday["13"] : "",
                    };



                });
        },
        getFakeUser(type, points) {
            var user = {};
            user.name = "Team Affiliate Pro";
            user.image = "https://secure.gravatar.com/avatar/7427f23abe55d3eaed1476976407bd54?s=100&d=//office.builderall.com/internacional/public/office2/new-layout/images/ic-no-user.png&r=g";
            if(type == 'month') user.points = points + 6;
            if(type == 'day')   user.points = points + 2;
            return user;
        },
        handleDateFormat(string) {
            if(!string) return '';
            let pad = function(num) { return ('00'+num).slice(-2) };
            let date = new Date(string);
            let year = date.getFullYear();
            let month = date.getMonth()+1;
            let day = date.getDate();
            let hour = date.getHours();
            let minute = date.getMinutes();
            let second = date.getSeconds();
            if(this.view.dados_usuario_office.pais == 'br') {
                return pad(hour) + ':' + pad(minute) + ':' + pad(second) + ' ' + pad(day) + '/' + pad(month) + '/' + year;
            } else {
                return pad(hour) + ':' + pad(minute) + ':' + pad(second) + ' ' + pad(month) + '/' + pad(day) + '/' + year;
            }
        }
    },
    mounted() {
        this.handleRanking();
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container-showcase {
    text-align: center;
    p {
        color: #5b5b5b;
        font-size: .9rem;
        font-weight: bold;
    }
    .btn__rank {
        color: white;
        background: var(--theme-color-primary);
        border-radius: 4px;
        margin: 2rem auto 1rem auto;
        display: inline-block;
        padding: 1.1rem 2.5rem;
        transition: 0.1s all ease;
        &:hover {
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        }
    }
    .title__rank {
        width: 100%;
        text-align: center;
    }
    .card {
        border: 1px solid #c6c6c6;
        padding: 0;
        margin-top: 0;
        border-radius: 0 0 7px 7px;
    }
    .last__updated {
        display: block;
        font-family: 'Muli-Regular';
        font-size: .85rem;
        text-align: left;
        padding-left: .8rem;
        margin-bottom: .5rem;
        &.first {
            margin-bottom: 0;
        }
    }
    .showcase {
        display: grid;
        grid-template-columns: 2fr 1fr;
        grid-column-gap: 10px;
        .rank__3 {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            .rank__3--in {
                display: flex;
                align-items: center;
                justify-content: space-around;
                border-right: 1px solid #c6c6c6;
                .rank__row {
                    display: flex;
                    flex-direction: column;
                    text-align: center;
                    font-size: 1rem;
                    .box__image {
                        position: relative;
                        img {
                            height: 130px;
                            width: auto;
                            margin: 0 1.5rem;
                            border-radius: 50%;
                            border: 4px solid var(--theme-color-primary);
                        }
                        .index {
                            background: var(--theme-color-primary);
                            width: max-content;
                            height: 30px;
                            width: 30px;
                            color: white;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                    &:nth-child(2) {
                        border-right: 1px solid #e5e5e5;
                        border-left: 1px solid #e5e5e5;
                        font-weight: bold;
                        .index {
                            background: #56e06c;
                        }
                        img {
                            border: 4px solid #56e06c;
                            height: 150px;
                        }
                    }
                    .index {
                        position: absolute;
                        bottom: -10px;
                        left: 0;
                        right: 0;
                        margin: auto;
                    }
                    .name {
                        margin: 2rem 0 0 0;
                    }
                    .name,
                    .points {
                        font-size: 1rem;
                    }
                }
            }
        }
        .customer {
            max-height: 300px;
            .customer__row {
                border-bottom: 1px solid #e5e5e5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 0.5rem 1rem;
                padding: 0.5rem 0;
                .box__left {
                    display: flex;
                    align-items: center;
                    .index {
                        font-weight: bold;
                        font-size: 1.2rem;
                    }
                    img {
                        height: 75px;
                        width: auto;
                        margin: 0 0.45rem;
                        border-radius: 50%;
                    }
                    h5 {
                        text-transform: capitalize;
                    }
                }
                .points {
                    padding: 0 0.5rem;
                    font-size: 1.2rem;
                }
            }
        }
    }
    .showcase__simplified {
        display: flex;
        justify-content: space-between;
        .left,
        .right {
            max-height: 500px;
            .customer__row {
                border-bottom: 1px solid #e5e5e5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 0.5rem 1rem;
                padding: 0.5rem 0;
                &:last-child {
                    border-bottom: none;
                }
                .box__left {
                    display: flex;
                    align-items: center;
                    .index {
                        font-weight: bold;
                        font-size: 1.2rem;
                    }
                    img {
                        height: 75px;
                        width: auto;
                        margin: 0 0.45rem;
                        border-radius: 50%;
                    }
                    h5 {
                        text-transform: capitalize;
                    }
                }
                .points {
                    padding: 0 0.5rem;
                    font-size: 1.2rem;
                }
            }
        }
        .left .customer__row {
            margin-left: 2rem;
        }
    }
}
@media (max-width: 1110px) {
    .showcase {
        grid-template-columns: 1fr !important;
    }
    .showcase__simplified {
        flex-direction: column;
        .left .customer__row {
            margin-left: 1rem !important;
        }
        .right {
            max-height: unset !important;
        }
    }
}
@media (max-width: 800px) {
    .rank__3 {
        flex-direction: column;
        .rank__row {
            border: 0 !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/affiliatesShowCase.vue